var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHard4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 30,
    viewBox: "0 0 90 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_802_2829)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.04985H10.9439L12.1418 2.09952L13.2915 2.20384L14.3931 2.46214L15.4418 2.72045L16.3894 3.13275L17.289 3.54505L18.1405 4.06166L18.939 4.62795L19.6365 5.24889L20.3341 5.91949L20.9354 6.63977L21.4838 7.4147L21.9312 8.23929L22.3833 9.06389L22.7345 9.94313L23.0328 10.8224L38.5756 0.5L44.2231 4.41932L32.1295 12.4716L34.0777 13.8128L46.2724 5.81518L51.5207 9.42652L39.4751 17.6328L41.5244 18.9243L53.7672 10.872V2.04985H62.7628V19.6446H70.7579V27.9005H53.7672V19.4359L38.6237 29.5L23.1819 18.7157L22.8836 19.6446L22.5854 20.5238L22.138 21.403L21.6858 22.2823L21.1374 23.0572L20.5361 23.8321L19.8867 24.5524L19.1362 25.1733L18.3858 25.7943L17.4862 26.3109L16.5867 26.7729L15.5861 27.1852L14.5374 27.4931L13.4358 27.7018L12.2861 27.8558L11.0353 27.9054H0V2.04985ZM8.5964 10.1518H10.9439L11.9926 10.2561L12.8441 10.5641L13.5945 11.026L14.2439 11.647L14.6961 12.3672L15.0473 13.1422L15.2493 14.0214L15.2975 14.9007L15.2493 15.7799L15.0473 16.6591L14.6961 17.4341L14.1958 18.1543L13.5945 18.7753L12.8441 19.2372L11.9445 19.5452L10.9439 19.6495H8.5964V10.1567V10.1518ZM73.0093 2.04985H82.053V19.6446H90V27.9005H73.0093V2.04985Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_802_2829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 29,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHard4);
export default __webpack_public_path__ + "static/media/hard4.e77999399e2c25480892ca10d1557438.svg";
export { ForwardRef as ReactComponent };